<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head"><b>DEDICATION</b></p>
<p class="txt">To my parents, Charles and Christine Miller, who led me to a deep, abiding faith in the Lord and introduced me to the treasures of our American ancestors.</p>
<p class="fig"><img alt="" src="images/pg4_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?b1325564